/* ZERON theme add-ons for Dawn */
(function () {
  'use strict';

  /* ---------- Money ---------- */
  function fmtNum(cents, decimals, thousands, decimal) {
    var n = (cents / 100).toFixed(decimals);
    var parts = n.split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
    return decimals ? parts[0] + decimal + parts[1] : parts[0];
  }
  function formatMoney(cents) {
    var format = (window.zrTheme && window.zrTheme.moneyFormat) || '{{amount}}';
    cents = Math.round(Number(cents) || 0);
    return format.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, key) {
      switch (key) {
        case 'amount': return fmtNum(cents, 2, ',', '.');
        case 'amount_no_decimals': return fmtNum(cents, 0, ',', '.');
        case 'amount_with_comma_separator': return fmtNum(cents, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return fmtNum(cents, 0, '.', ',');
        case 'amount_with_apostrophe_separator': return fmtNum(cents, 2, "'", '.');
        case 'amount_with_space_separator': return fmtNum(cents, 2, ' ', ',');
        default: return fmtNum(cents, 2, '.', ',');
      }
    });
  }
  window.zrFormatMoney = formatMoney;

  function onVariantChange(cb) {
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.variantChange, function (e) { if (e && e.data && e.data.variant) cb(e.data.variant, e.data.sectionId); });
    }
  }

  /* ---------- Quantity breaks ---------- */
  if (!customElements.get('zr-qty-breaks')) {
    customElements.define('zr-qty-breaks', class extends HTMLElement {
      connectedCallback() {
        var self = this;
        try { this.cfg = JSON.parse(this.querySelector('script[type="application/json"]').textContent); } catch (e) { this.cfg = { options: [] }; }
        this.qtyInput = this.querySelector('input[name="quantity"]');
        this.addEventListener('change', function (e) {
          if (e.target && e.target.matches('input[type="radio"]')) self.select(e.target);
        });
        var checked = this.querySelector('input[type="radio"]:checked');
        if (checked) this.select(checked);
        onVariantChange(function (variant, sectionId) {
          if (sectionId && self.dataset.section && sectionId !== self.dataset.section) return;
          self.render(variant.price, variant.compare_at_price);
        });
      }
      select(input) {
        this.querySelectorAll('.zr-qb__opt').forEach(function (o) { o.classList.toggle('is-selected', o.contains(input)); });
        if (this.qtyInput) this.qtyInput.value = input.value;
      }
      render(price, compare) {
        var opts = this.cfg.options || [];
        this.querySelectorAll('.zr-qb__opt').forEach(function (el, i) {
          var o = opts[i]; if (!o) return;
          var q = o.q;
          var full = price * q;
          var base = o.compareMode === 'compare_price' && compare && compare > price ? compare * q : full;
          var off = Math.round(full * (o.pct || 0) / 100) + Math.round((o.fixed || 0) * 100);
          var total = Math.max(0, full - off);
          var saved = Math.max(0, base - total);
          el.querySelectorAll('[data-zr-price]').forEach(function (n) { n.textContent = formatMoney(total); });
          el.querySelectorAll('[data-zr-compare]').forEach(function (n) { n.textContent = formatMoney(base); });
          el.querySelectorAll('[data-zr-saved]').forEach(function (n) { n.textContent = formatMoney(saved); });
          el.querySelectorAll('.zr-qb__compare').forEach(function (n) { n.hidden = base <= total; });
        });
      }
    });
  }

  /* ---------- Dates ---------- */
  function addDays(d, n, skip) {
    var r = new Date(d.getTime()); var added = 0;
    while (added < n) { r.setDate(r.getDate() + 1); if (skip.indexOf(r.getDay()) === -1) added++; }
    return r;
  }
  function fmtDate(d, format, days, months) {
    var dayName = days[(d.getDay() + 6) % 7] || '';
    var mon = months[d.getMonth()] || '';
    var dd = d.getDate();
    switch (format) {
      case 'day_dd_mm': return dayName + ', ' + dd + ' ' + mon;
      case 'dd_mm': return dd + ' ' + mon;
      case 'mm_dd': return mon + ' ' + dd;
      case 'day_mm_dd': return dayName + ', ' + mon + ' ' + dd;
      case 'dd_mm_numeric': return ('0' + dd).slice(-2) + '.' + ('0' + (d.getMonth() + 1)).slice(-2);
      default: return dd + ' ' + mon;
    }
  }
  function splitList(s) { return String(s || '').split(',').map(function (x) { return x.trim(); }); }
  function initDates(root) {
    root.querySelectorAll('[data-zr-dates]').forEach(function (el) {
      var c; try { c = JSON.parse(el.getAttribute('data-zr-dates')); } catch (e) { return; }
      var days = splitList(c.days), months = splitList(c.months);
      var skipNames = splitList(c.skip).filter(Boolean);
      var skip = [];
      skipNames.forEach(function (n) { var i = days.indexOf(n); if (i > -1) skip.push((i + 1) % 7); });
      var now = new Date();
      el.querySelectorAll('[data-min]').forEach(function (t) {
        var a = addDays(now, parseInt(t.getAttribute('data-min'), 10) || 0, skip);
        var b = addDays(now, parseInt(t.getAttribute('data-max'), 10) || 0, skip);
        var tpl = t.getAttribute('data-tpl') || '';
        t.innerHTML = tpl.split('[start_date]').join(fmtDate(a, c.format, days, months)).split('[end_date]').join(fmtDate(b, c.format, days, months));
      });
    });
  }

  /* ---------- Countdown ---------- */
  function initCountdowns(root) {
    root.querySelectorAll('[data-zr-countdown]').forEach(function (el) {
      if (el.dataset.zrInit) return; el.dataset.zrInit = '1';
      var end = Date.parse(el.getAttribute('data-end') || '') || 0;
      var repeatH = parseInt(el.getAttribute('data-repeat'), 10) || 24;
      var behavior = el.getAttribute('data-behavior') || 'next_day';
      function target() {
        var now = Date.now();
        if (end > now) return end;
        if (behavior === 'hide') return 0;
        var period = repeatH * 3600000;
        var midnight = new Date(); midnight.setHours(0, 0, 0, 0);
        var t = midnight.getTime();
        while (t <= now) t += period;
        return t;
      }
      var units = {
        d: el.querySelector('[data-u="d"]'), h: el.querySelector('[data-u="h"]'),
        m: el.querySelector('[data-u="m"]'), s: el.querySelector('[data-u="s"]')
      };
      function pad(n) { return (n < 10 ? '0' : '') + n; }
      function tick() {
        var t = target();
        if (!t) { el.hidden = true; return; }
        var diff = Math.max(0, Math.floor((t - Date.now()) / 1000));
        var d = Math.floor(diff / 86400), h = Math.floor(diff / 3600) % 24, m = Math.floor(diff / 60) % 60, s = diff % 60;
        if (!units.d) h += d * 24;
        if (units.d) units.d.textContent = pad(d);
        if (units.h) units.h.textContent = pad(h);
        if (units.m) units.m.textContent = pad(m);
        if (units.s) units.s.textContent = pad(s);
      }
      tick(); setInterval(tick, 1000);
    });
  }

  /* ---------- Simple sliders (reviews) ---------- */
  function initSliders(root) {
    root.querySelectorAll('[data-zr-slider]').forEach(function (el) {
      if (el.dataset.zrInit) return; el.dataset.zrInit = '1';
      var track = el.querySelector('.zr-reviews__track');
      var slides = track ? track.children : [];
      var dots = el.querySelector('.zr-dots');
      if (!track || slides.length < 2) { if (dots) dots.hidden = true; return; }
      var idx = 0;
      if (dots) {
        for (var i = 0; i < slides.length; i++) {
          var b = document.createElement('button'); b.type = 'button'; b.setAttribute('aria-label', (i + 1) + '/' + slides.length);
          (function (n) { b.addEventListener('click', function () { go(n); restart(); }); })(i);
          dots.appendChild(b);
        }
      }
      function mark() { if (dots) Array.prototype.forEach.call(dots.children, function (d, i) { d.setAttribute('aria-current', i === idx ? 'true' : 'false'); }); }
      function go(n) { idx = (n + slides.length) % slides.length; track.scrollTo({ left: slides[idx].offsetLeft - track.offsetLeft, behavior: 'smooth' }); mark(); }
      track.addEventListener('scroll', function () {
        var w = track.clientWidth || 1; var n = Math.round(track.scrollLeft / w);
        if (n !== idx) { idx = n; mark(); }
      }, { passive: true });
      mark();
      var auto = el.getAttribute('data-autoplay') === 'true';
      var speed = (parseInt(el.getAttribute('data-speed'), 10) || 4) * 1000;
      var timer = null;
      function restart() { if (!auto) return; clearInterval(timer); timer = setInterval(function () { go(idx + 1); }, speed); }
      el.addEventListener('mouseenter', function () { clearInterval(timer); });
      el.addEventListener('mouseleave', restart);
      restart();
    });
  }

  /* ---------- Sticky ATC ---------- */
  function initSticky(root) {
    root.querySelectorAll('[data-zr-sticky]').forEach(function (bar) {
      if (bar.dataset.zrInit) return; bar.dataset.zrInit = '1';
      if (bar.parentNode !== document.body && !window.Shopify?.designMode) document.body.appendChild(bar);
      var formId = bar.getAttribute('data-form');
      var anchor = document.getElementById('ProductSubmitButton-' + bar.getAttribute('data-section')) || document.getElementById(formId);
      var always = bar.getAttribute('data-when') === 'always';
      function update() {
        var show = always;
        if (!always && anchor) { var r = anchor.getBoundingClientRect(); show = r.bottom < 0; }
        bar.classList.toggle('is-visible', show);
        document.body.classList.toggle('zr-sticky-on', show);
      }
      window.addEventListener('scroll', update, { passive: true });
      update();
      var btn = bar.querySelector('.zr-sticky__btn');
      if (btn) btn.addEventListener('click', function (e) {
        e.preventDefault();
        var mode = bar.getAttribute('data-function');
        var main = document.getElementById('ProductSubmitButton-' + bar.getAttribute('data-section'));
        if (mode === 'scroll' || !main) {
          var target = document.getElementById('MainProduct-' + bar.getAttribute('data-section')) || anchor;
          if (target) target.scrollIntoView({ behavior: 'smooth', block: 'start' });
          return;
        }
        if (main.disabled) { main.scrollIntoView({ behavior: 'smooth', block: 'center' }); return; }
        main.click();
      });
      onVariantChange(function (variant, sectionId) {
        if (sectionId !== bar.getAttribute('data-section')) return;
        var p = bar.querySelector('[data-zr-sticky-price]'); var c = bar.querySelector('[data-zr-sticky-compare]');
        if (p) p.textContent = formatMoney(variant.price);
        if (c) { c.textContent = variant.compare_at_price > variant.price ? formatMoney(variant.compare_at_price) : ''; }
        var bp = bar.querySelector('[data-zr-sticky-btnprice]'); if (bp) bp.textContent = formatMoney(variant.price);
        if (btn) btn.disabled = !variant.available;
      });
    });
  }

  /* ---------- Result rings ---------- */
  function initRings(root) {
    var rings = root.querySelectorAll('.zr-ring[data-pct]');
    if (!rings.length) return;
    function fill(r) {
      var c = r.querySelector('.zr-ring__fg'); if (!c) return;
      var len = parseFloat(c.getAttribute('data-len'));
      c.style.strokeDashoffset = String(len * (1 - Math.min(100, parseFloat(r.getAttribute('data-pct')) || 0) / 100));
    }
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (ents) { ents.forEach(function (e) { if (e.isIntersecting) { fill(e.target); io.unobserve(e.target); } }); }, { threshold: .3 });
      rings.forEach(function (r) { io.observe(r); });
    } else rings.forEach(fill);
  }

  /* ---------- Scroll to top ---------- */
  function initTop() {
    var b = document.querySelector('[data-zr-top]'); if (!b || b.dataset.zrInit) return; b.dataset.zrInit = '1';
    var after = parseInt(b.getAttribute('data-after'), 10) || 400;
    function u() { b.classList.toggle('is-visible', window.scrollY > after); }
    window.addEventListener('scroll', u, { passive: true }); u();
    b.addEventListener('click', function () { window.scrollTo({ top: 0, behavior: 'smooth' }); });
  }

  /* ---------- Cart drawer timer ---------- */
  function initCartTimer(root) {
    root.querySelectorAll('[data-zr-cart-timer]').forEach(function (el) {
      if (el.dataset.zrInit) return; el.dataset.zrInit = '1';
      var dur = parseInt(el.getAttribute('data-duration'), 10) || 300;
      var key = 'zr_cart_timer_end', end;
      try { end = parseInt(sessionStorage.getItem(key), 10); } catch (e) {}
      if (!end || end < Date.now()) { end = Date.now() + dur * 1000; try { sessionStorage.setItem(key, String(end)); } catch (e) {} }
      var slot = el.querySelector('[data-zr-timer]');
      function tick() {
        var s = Math.max(0, Math.floor((end - Date.now()) / 1000));
        if (s === 0) { end = Date.now() + dur * 1000; try { sessionStorage.setItem(key, String(end)); } catch (e) {} }
        if (slot) slot.textContent = ('0' + Math.floor(s / 60)).slice(-2) + ':' + ('0' + (s % 60)).slice(-2);
      }
      tick(); setInterval(tick, 1000);
    });
  }

  function initAll(root) {
    root = root || document;
    initDates(root); initCountdowns(root); initSliders(root); initSticky(root); initRings(root); initCartTimer(root);
  }

  function boot() {
    initAll(document); initTop();
    // bridge Dawn cart events to plain DOM events (used by ZERON cart boost)
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function () { document.dispatchEvent(new CustomEvent('cart:update')); setTimeout(function () { initCartTimer(document); }, 50); });
    }
    if ('MutationObserver' in window) {
      var t; new MutationObserver(function () { clearTimeout(t); t = setTimeout(function () { initCartTimer(document); }, 150); })
        .observe(document.body, { childList: true, subtree: true });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); initTop(); });
})();
